'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useCallback } from 'react';
import { connect } from 'react-redux';
import debounce from 'transmute/debounce';
import TrackedRoute from 'AdsUI/lib/TrackedRoute';
import { getCampaignRequestStatus, getCampaignForCampaignDetails } from 'AdsUI/selectors/CampaignReportingSelectors';
import CampaignDetailsPage from 'AdsUI/components/campaign-details/CampaignDetailsPage';
import { getAdAccountFromParams } from 'AdsUI/selectors/AccountsSelectors';
import { getNetworkFromParams } from 'AdsUI/selectors/PropsSelectors';
import { EntityTypes, AdWordsCampaignTypes, Networks } from 'AdsUI/lib/Constants';
import { updateReportingEntity } from 'AdsUI/actions/CampaignReportingActions';
import { getGlobalFilters } from 'AdsUI/selectors/GlobalFilters';
import { Switch } from 'react-router-dom';
import CampaignManagementPanelContainer from 'AdsUI/containers/campaign-details/CampaignManagementPanelContainer';
import ChildrenManagementPanelContainer from 'AdsUI/containers/campaign-details/ChildrenManagementPanelContainer';
const DEBOUNCE_DELAY = 500;

const CampaignDetailsPageContainer = ({
  adAccount,
  network,
  globalFilters,
  campaignDetails,
  campaignRequestStatus,
  match: {
    params: {
      campaignId
    }
  },
  history,
  location: {
    pathname
  },
  children,
  dispatch
}) => {
  const onChangeCampaignName = useMemo(() => {
    const onChange = name => dispatch(updateReportingEntity(network, adAccount, campaignDetails.entity, EntityTypes.CAMPAIGN, campaignId, null, {
      name
    }));

    return debounce(DEBOUNCE_DELAY, onChange);
  }, [adAccount, campaignId, dispatch, campaignDetails, network]);
  const onEditCampaign = useCallback(() => {
    history.push(`/${adAccount.network.toLowerCase()}/${adAccount.accountId}/campaigns/${campaignDetails.entity.id}/edit/details`);
  }, [history, adAccount, campaignDetails]);
  const onOpenCampaignPanel = useCallback(() => {
    history.push(`${pathname}/manage-campaign${window.location.search}`);
  }, [history, pathname]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(TrackedRoute, {
        path: "/accounts/:network/:accountId/campaigns/:campaignId/manage-campaign",
        component: CampaignManagementPanelContainer,
        name: "campaign-details-manage-campaign",
        exact: true
      }), /*#__PURE__*/_jsx(TrackedRoute, {
        path: "/accounts/:network/:accountId/campaigns/:campaignId/adgroups/:entityId/manage",
        component: ChildrenManagementPanelContainer,
        name: "campaign-details-manage-campaign",
        exact: true
      }), /*#__PURE__*/_jsx(TrackedRoute, {
        path: "/accounts/:network/:accountId/campaigns/:campaignId/adgroups/:adGroupId/keywords/manage-campaign",
        component: CampaignManagementPanelContainer,
        name: "campaign-details-manage-campaign",
        exact: true
      }), /*#__PURE__*/_jsx(TrackedRoute, {
        path: "/accounts/:network/:accountId/campaigns/:campaignId/adgroups/:adGroupId/negative-keywords/manage-campaign",
        component: CampaignManagementPanelContainer,
        name: "campaign-details-manage-campaign",
        exact: true
      }), /*#__PURE__*/_jsx(TrackedRoute, {
        path: "/accounts/:network/:accountId/campaigns/:campaignId/adgroups/:adGroupId/keywords/:entityId/manage",
        component: ChildrenManagementPanelContainer,
        name: "campaign-details-manage-keyword",
        exact: true
      }), /*#__PURE__*/_jsx(TrackedRoute, {
        path: "/accounts/:network/:accountId/campaigns/:campaignId/adgroups/:adGroupId/manage-campaign",
        component: CampaignManagementPanelContainer,
        name: "campaign-details-manage-campaign",
        exact: true
      }), /*#__PURE__*/_jsx(TrackedRoute, {
        path: "/accounts/:network/:accountId/campaigns/:campaignId/adgroups/:adGroupId/ads/:entityId/manage",
        component: ChildrenManagementPanelContainer,
        name: "campaign-details-manage-ad",
        exact: true
      })]
    }), /*#__PURE__*/_jsx(CampaignDetailsPage, {
      loading: !campaignRequestStatus.fetchedSuccessfully(),
      campaignId: campaignId,
      timeRange: globalFilters.timeRange,
      attributionView: globalFilters.attributionView,
      campaignDetails: campaignDetails,
      network: network,
      adAccount: adAccount,
      canEditCampaignName: adAccount.canManageEntities,
      showCampaignManagement: !!campaignDetails && !!campaignDetails.entity && campaignDetails.entity.manageable && (campaignDetails.entity.network !== Networks.ADWORDS || campaignDetails.type !== AdWordsCampaignTypes.VIDEO),
      campaignStatus: campaignDetails && campaignDetails.entity && campaignDetails.entity.status,
      onChangeCampaignName: onChangeCampaignName,
      onEditCampaign: onEditCampaign,
      onOpenCampaignPanel: onOpenCampaignPanel
    }), children]
  });
};

const mapStateToProps = (state, props) => ({
  adAccount: getAdAccountFromParams(state, props),
  network: getNetworkFromParams(state, props),
  globalFilters: getGlobalFilters(state),
  campaignDetails: getCampaignForCampaignDetails(state, props),
  campaignRequestStatus: getCampaignRequestStatus(state, props)
});

export default connect(mapStateToProps)(CampaignDetailsPageContainer);